var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRemovebgPreview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "708px",
    height: "334px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.995
    },
    fill: "#abb0b3",
    d: "M 153.5,72.5 C 154.209,73.404 155.209,73.7373 156.5,73.5C 191.866,84.378 214.366,108.045 224,144.5C 230.721,181.86 220.221,213.36 192.5,239C 162.924,262.11 130.257,267.443 94.5,255C 56.1852,237.568 35.8519,207.734 33.5,165.5C 35.9944,121.863 57.3277,91.6963 97.5,75C 115.981,68.827 134.648,67.9936 153.5,72.5 Z M 129.5,139.5 C 130.477,136.713 130.81,133.713 130.5,130.5C 124.974,130.179 119.64,130.512 114.5,131.5C 112.167,131.5 109.833,131.5 107.5,131.5C 108.382,117.018 112.216,103.351 119,90.5C 121.815,84.8309 126.315,82.9976 132.5,85C 137.346,89.174 140.846,94.3406 143,100.5C 152.012,128.837 155.179,157.837 152.5,187.5C 136.837,188.767 121.171,188.767 105.5,187.5C 104.222,171.842 104.222,156.176 105.5,140.5C 113.525,140.61 121.525,140.276 129.5,139.5 Z M 108.5,87.5 C 109.167,87.5 109.5,87.8333 109.5,88.5C 107.616,91.6035 106.282,94.9368 105.5,98.5C 104.733,99.172 104.066,100.005 103.5,101C 103.728,101.399 104.062,101.565 104.5,101.5C 101.331,111.671 98.664,122.005 96.5,132.5C 81.1182,134.405 66.4515,138.738 52.5,145.5C 59.7609,115.566 78.4275,96.2323 108.5,87.5 Z M 155.5,88.5 C 182.341,98.0074 200.008,116.341 208.5,143.5C 208.672,144.492 208.338,145.158 207.5,145.5C 201.934,142.225 195.934,139.725 189.5,138C 181.864,136.008 174.197,134.174 166.5,132.5C 164.022,117.9 160.022,103.9 154.5,90.5C 154.833,89.8333 155.167,89.1667 155.5,88.5 Z M 94.5,142.5 C 95.4767,145.287 95.81,148.287 95.5,151.5C 94.5422,159.186 94.5422,166.852 95.5,174.5C 96.0803,178.649 95.4136,182.316 93.5,185.5C 79.7667,183.645 66.7667,179.478 54.5,173C 47.4861,167.943 46.8194,162.276 52.5,156C 65.4853,148.419 79.4853,143.919 94.5,142.5 Z M 168.5,142.5 C 182.292,144.73 195.292,149.23 207.5,156C 212.23,160.344 212.73,165.177 209,170.5C 196.415,178.752 182.581,183.752 167.5,185.5C 167.5,174.167 167.5,162.833 167.5,151.5C 167.264,148.391 167.597,145.391 168.5,142.5 Z M 109.5,241.5 C 109.5,242.833 108.833,243.5 107.5,243.5C 79.3336,234.835 61.1669,216.501 53,188.5C 66.413,195.064 80.5797,199.23 95.5,201C 113.452,203.498 131.452,203.998 149.5,202.5C 148.394,215.984 144.561,228.651 138,240.5C 134.723,246.109 129.89,247.942 123.5,246C 119.792,242.09 116.958,237.59 115,232.5C 112.39,224.839 109.89,217.172 107.5,209.5C 104.979,210.785 102.313,211.452 99.5,211.5C 101.44,221.988 104.774,231.988 109.5,241.5 Z M 156.5,242.5 C 155.167,242.5 154.5,241.833 154.5,240.5C 159.848,228.714 163.181,216.714 164.5,204.5C 165.345,203.329 166.011,201.995 166.5,200.5C 180.829,199.21 194.329,195.21 207,188.5C 199.421,214.92 182.588,232.92 156.5,242.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.194
    },
    fill: "#44454f",
    d: "M 156.5,73.5 C 155.209,73.7373 154.209,73.404 153.5,72.5C 153.435,72.0618 153.601,71.7284 154,71.5C 154.995,72.0659 155.828,72.7326 156.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.718
    },
    fill: "#82858b",
    d: "M 325.5,86.5 C 339.323,85.5042 353.323,85.1709 367.5,85.5C 367.825,92.6866 367.491,99.6866 366.5,106.5C 366.5,99.8333 366.5,93.1667 366.5,86.5C 352.833,86.5 339.167,86.5 325.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.723
    },
    fill: "#898d92",
    d: "M 575.5,86.5 C 554.5,86.5 533.5,86.5 512.5,86.5C 512.5,93.1667 512.5,99.8333 512.5,106.5C 511.509,99.6866 511.175,92.6866 511.5,85.5C 533.007,85.1694 554.34,85.5027 575.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.039
    },
    fill: "#1e1e28",
    d: "M 108.5,87.5 C 108.56,86.9569 108.893,86.6236 109.5,86.5C 110.773,87.2565 110.773,87.9232 109.5,88.5C 109.5,87.8333 109.167,87.5 108.5,87.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#aeb4b6",
    d: "M 325.5,86.5 C 339.167,86.5 352.833,86.5 366.5,86.5C 366.5,93.1667 366.5,99.8333 366.5,106.5C 354.007,107.331 341.34,107.831 328.5,108C 325.854,108.804 323.854,110.304 322.5,112.5C 320.587,115.04 320.254,117.707 321.5,120.5C 322.558,123.397 324.558,125.564 327.5,127C 344.468,124.936 358.635,130.102 370,142.5C 379.536,165.911 372.702,182.411 349.5,192C 335.258,192.823 321.092,192.656 307,191.5C 306.189,184.586 306.355,177.752 307.5,171C 319.833,170.667 332.167,170.333 344.5,170C 352.318,166.547 354.151,161.047 350,153.5C 349.097,152.299 347.931,151.465 346.5,151C 339.229,149.818 331.896,149.151 324.5,149C 305.809,142.958 297.643,130.125 300,110.5C 303.517,97.148 312.017,89.148 325.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#afb4b7",
    d: "M 433.5,179.5 C 429.217,178.173 424.551,177.507 419.5,177.5C 414.654,177.501 409.988,177.834 405.5,178.5C 403.475,183.385 400.808,187.885 397.5,192C 389.841,192.5 382.174,192.666 374.5,192.5C 374.34,190.801 374.506,189.134 375,187.5C 393.167,153.833 411.333,120.167 429.5,86.5C 438.059,85.1847 446.559,85.1847 455,86.5C 455.667,121.167 455.667,155.833 455,190.5C 448.115,192.441 440.948,193.108 433.5,192.5C 433.5,188.167 433.5,183.833 433.5,179.5 Z M 431.5,129.5 C 432.167,130.167 432.833,130.833 433.5,131.5C 433.5,138.833 433.5,146.167 433.5,153.5C 432.596,154.209 432.263,155.209 432.5,156.5C 428.154,156.666 423.821,156.499 419.5,156C 418.944,155.617 418.611,155.117 418.5,154.5C 420.195,152.103 421.528,149.437 422.5,146.5C 424.104,145.713 424.771,144.38 424.5,142.5C 427.072,138.361 429.405,134.027 431.5,129.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b0b6b8",
    d: "M 469.5,86.5 C 476.167,86.5 482.833,86.5 489.5,86.5C 489.169,114.672 489.502,142.672 490.5,170.5C 518.328,171.498 546.328,171.831 574.5,171.5C 575.254,174.023 575.92,176.689 576.5,179.5C 575.561,183.765 575.228,188.098 575.5,192.5C 540.165,192.667 504.832,192.5 469.5,192C 468.168,156.736 468.168,121.569 469.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.999
    },
    fill: "#b0b5b8",
    d: "M 575.5,86.5 C 575.363,89.5581 575.696,92.7248 576.5,96C 575.833,99.6667 575.167,103.333 574.5,107C 553.663,107.829 532.996,107.663 512.5,106.5C 512.5,99.8333 512.5,93.1667 512.5,86.5C 533.5,86.5 554.5,86.5 575.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.998
    },
    fill: "#adb3b5",
    d: "M 658.5,144.5 C 658.427,146.027 659.094,147.027 660.5,147.5C 664.653,158.78 663.32,169.447 656.5,179.5C 654.167,181.167 652.167,183.167 650.5,185.5C 646.768,188.453 642.602,190.787 638,192.5C 623.797,192.807 609.464,192.474 595,191.5C 594.205,184.782 594.372,178.116 595.5,171.5C 608.154,170.667 620.82,170.167 633.5,170C 640.482,166.787 642.315,161.62 639,154.5C 637.833,153.333 636.667,152.167 635.5,151C 627.946,150.892 620.279,150.226 612.5,149C 591.938,141.379 584.438,126.879 590,105.5C 594.812,95.3539 602.646,88.8539 613.5,86C 627.496,85.5001 641.496,85.3334 655.5,85.5C 655.211,89.1064 655.544,92.6064 656.5,96C 655.833,99.6667 655.167,103.333 654.5,107C 642.167,107.333 629.833,107.667 617.5,108C 610.89,110.208 608.724,114.708 611,121.5C 611.774,123.939 613.274,125.773 615.5,127C 631.37,124.592 645.037,129.092 656.5,140.5C 657.18,141.86 657.847,143.193 658.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.026
    },
    fill: "#383943",
    d: "M 155.5,88.5 C 155.167,89.1667 154.833,89.8333 154.5,90.5C 152.912,89.3647 152.579,88.0314 153.5,86.5C 154.522,86.8555 155.189,87.5222 155.5,88.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.726
    },
    fill: "#898d92",
    d: "M 469.5,86.5 C 476.313,85.5088 483.313,85.1755 490.5,85.5C 490.5,113.5 490.5,141.5 490.5,169.5C 490.5,169.833 490.5,170.167 490.5,170.5C 489.502,142.672 489.169,114.672 489.5,86.5C 482.833,86.5 476.167,86.5 469.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.667
    },
    fill: "#4c4e57",
    d: "M 105.5,98.5 C 105.737,99.791 105.404,100.791 104.5,101.5C 104.062,101.565 103.728,101.399 103.5,101C 104.066,100.005 104.733,99.172 105.5,98.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.706
    },
    fill: "#585a62",
    d: "M 322.5,112.5 C 321.96,115.393 321.627,118.06 321.5,120.5C 320.254,117.707 320.587,115.04 322.5,112.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.996
    },
    fill: "#a8aeb0",
    d: "M 513.5,127.5 C 533.836,127.333 554.169,127.5 574.5,128C 576.08,134.719 576.58,141.553 576,148.5C 570.998,150.027 565.831,150.694 560.5,150.5C 545.097,149.911 529.764,149.911 514.5,150.5C 513.833,150.167 513.167,149.833 512.5,149.5C 510.928,141.917 511.262,134.584 513.5,127.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.024
    },
    fill: "#2c2c37",
    d: "M 433.5,131.5 C 432.833,130.833 432.167,130.167 431.5,129.5C 431.709,128.078 432.209,126.745 433,125.5C 433.495,127.473 433.662,129.473 433.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.441
    },
    fill: "#585a62",
    d: "M 114.5,131.5 C 119.64,130.512 124.974,130.179 130.5,130.5C 130.81,133.713 130.477,136.713 129.5,139.5C 129.5,136.833 129.5,134.167 129.5,131.5C 124.5,131.5 119.5,131.5 114.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.229
    },
    fill: "#373842",
    d: "M 94.5,142.5 C 94.56,141.957 94.8933,141.624 95.5,141.5C 96.8056,144.98 96.8056,148.313 95.5,151.5C 95.81,148.287 95.4767,145.287 94.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.008
    },
    fill: "#373842",
    d: "M 424.5,142.5 C 424.771,144.38 424.104,145.713 422.5,146.5C 422.66,144.847 423.326,143.514 424.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.137
    },
    fill: "#3e3f48",
    d: "M 208.5,143.5 C 209.776,144.386 209.776,145.386 208.5,146.5C 207.893,146.376 207.56,146.043 207.5,145.5C 208.338,145.158 208.672,144.492 208.5,143.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.438
    },
    fill: "#4e4f58",
    d: "M 168.5,142.5 C 167.597,145.391 167.264,148.391 167.5,151.5C 166.842,150.207 166.508,148.707 166.5,147C 166.569,145.014 167.235,143.514 168.5,142.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.243
    },
    fill: "#4d4e57",
    d: "M 658.5,144.5 C 659.906,144.973 660.573,145.973 660.5,147.5C 659.094,147.027 658.427,146.027 658.5,144.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.739
    },
    fill: "#707379",
    d: "M 433.5,153.5 C 433.5,154.833 433.5,156.167 433.5,157.5C 428.156,157.666 422.823,157.499 417.5,157C 416.434,155.841 416.767,155.008 418.5,154.5C 418.611,155.117 418.944,155.617 419.5,156C 423.821,156.499 428.154,156.666 432.5,156.5C 432.263,155.209 432.596,154.209 433.5,153.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.469
    },
    fill: "#64666e",
    d: "M 490.5,169.5 C 518.598,170.159 546.598,170.825 574.5,171.5C 546.328,171.831 518.328,171.498 490.5,170.5C 490.5,170.167 490.5,169.833 490.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.442
    },
    fill: "#61636b",
    d: "M 405.5,178.5 C 409.988,177.834 414.654,177.501 419.5,177.5C 424.551,177.507 429.217,178.173 433.5,179.5C 424.25,178.528 414.917,178.195 405.5,178.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.222
    },
    fill: "#42434c",
    d: "M 95.5,174.5 C 96.4834,178.298 96.8168,182.298 96.5,186.5C 95.209,186.737 94.209,186.404 93.5,185.5C 95.4136,182.316 96.0803,178.649 95.5,174.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#393a43",
    d: "M 656.5,179.5 C 655.5,182.5 653.5,184.5 650.5,185.5C 652.167,183.167 654.167,181.167 656.5,179.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.451
    },
    fill: "#454650",
    d: "M 166.5,200.5 C 166.011,201.995 165.345,203.329 164.5,204.5C 164.157,202.517 164.824,201.183 166.5,200.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#acb1b4",
    d: "M 308.5,232.5 C 306.577,236.029 305.911,240.029 306.5,244.5C 304.167,244.5 301.833,244.5 299.5,244.5C 299.5,231.833 299.5,219.167 299.5,206.5C 306.589,206.116 313.589,206.616 320.5,208C 329.846,216.715 329.18,224.715 318.5,232C 315.115,233.199 311.782,233.366 308.5,232.5 Z M 307.5,214.5 C 309.857,214.337 312.19,214.503 314.5,215C 319.368,217.477 319.701,220.477 315.5,224C 312.854,224.497 310.187,224.664 307.5,224.5C 307.5,221.167 307.5,217.833 307.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#b3b9bb",
    d: "M 331.5,206.5 C 333.833,206.5 336.167,206.5 338.5,206.5C 337.858,217.221 338.525,227.554 340.5,237.5C 345.179,237.334 349.845,237.501 354.5,238C 354.784,239.956 354.784,242.123 354.5,244.5C 346.833,244.5 339.167,244.5 331.5,244.5C 331.5,231.833 331.5,219.167 331.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.461
    },
    fill: "#5f6169",
    d: "M 338.5,206.5 C 339.189,216.735 339.855,227.068 340.5,237.5C 338.525,227.554 337.858,217.221 338.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#abb1b3",
    d: "M 385.5,206.5 C 385.5,219.167 385.5,231.833 385.5,244.5C 383.167,244.5 380.833,244.5 378.5,244.5C 378.019,241.57 376.186,240.237 373,240.5C 369.507,239.78 367.34,241.113 366.5,244.5C 363.167,245.833 359.833,245.833 356.5,244.5C 363.167,232.167 369.833,219.833 376.5,207.5C 379.428,206.516 382.428,206.183 385.5,206.5 Z M 374.5,232.5 C 374.5,231.5 374.5,230.5 374.5,229.5C 375.801,228.118 376.634,226.452 377,224.5C 377.654,223.304 378.154,223.304 378.5,224.5C 378.119,226.741 377.952,229.074 378,231.5C 376.989,232.337 375.822,232.67 374.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#abb1b3",
    d: "M 406.5,214.5 C 405.506,224.319 405.173,234.319 405.5,244.5C 403.167,244.5 400.833,244.5 398.5,244.5C 398.5,234.167 398.5,223.833 398.5,213.5C 395.833,213.5 393.167,213.5 390.5,213.5C 389.532,211.393 389.198,209.059 389.5,206.5C 393.524,206.497 397.524,206.164 401.5,205.5C 405.5,206 409.5,206.5 413.5,207C 415.621,213.288 413.288,215.788 406.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.99
    },
    fill: "#afb5b8",
    d: "M 417.5,206.5 C 425.167,206.5 432.833,206.5 440.5,206.5C 440.5,209.167 440.5,211.833 440.5,214.5C 435.5,214.5 430.5,214.5 425.5,214.5C 424.527,216.948 424.194,219.615 424.5,222.5C 427.167,222.5 429.833,222.5 432.5,222.5C 433.833,224.833 433.833,227.167 432.5,229.5C 429.833,229.5 427.167,229.5 424.5,229.5C 424.5,234.833 424.5,240.167 424.5,245.5C 421.941,245.802 419.607,245.468 417.5,244.5C 417.5,231.833 417.5,219.167 417.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#abb0b3",
    d: "M 475.5,206.5 C 481.509,206.334 487.509,206.501 493.5,207C 500.09,210.882 503.09,216.216 502.5,223C 500.021,226.313 497.355,229.48 494.5,232.5C 496.808,236.777 498.808,241.11 500.5,245.5C 497.102,245.82 493.768,245.487 490.5,244.5C 488.392,241.843 487.059,238.843 486.5,235.5C 486.573,233.973 485.906,232.973 484.5,232.5C 483.883,232.611 483.383,232.944 483,233.5C 482.501,237.152 482.335,240.818 482.5,244.5C 480.167,244.5 477.833,244.5 475.5,244.5C 475.5,231.833 475.5,219.167 475.5,206.5 Z M 483.5,214.5 C 489.831,213.029 492.998,215.362 493,221.5C 490.441,224.349 487.274,225.183 483.5,224C 482.208,220.835 482.208,217.668 483.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.994
    },
    fill: "#adb3b5",
    d: "M 529.5,206.5 C 529.334,214.174 529.5,221.841 530,229.5C 530.513,228.473 531.013,227.473 531.5,226.5C 534.216,220.067 537.216,213.734 540.5,207.5C 543.768,206.513 547.102,206.18 550.5,206.5C 550.5,219.167 550.5,231.833 550.5,244.5C 548.167,244.5 545.833,244.5 543.5,244.5C 543.831,237.137 543.497,229.803 542.5,222.5C 541.893,222.624 541.56,222.957 541.5,223.5C 541.443,224.609 541.11,225.609 540.5,226.5C 538.029,232.776 535.029,238.776 531.5,244.5C 528.5,244.5 525.5,244.5 522.5,244.5C 522.666,236.826 522.5,229.159 522,221.5C 521.487,222.527 520.987,223.527 520.5,224.5C 518.112,231.776 514.779,238.609 510.5,245C 507.518,245.498 504.518,245.665 501.5,245.5C 507.417,232.499 513.75,219.666 520.5,207C 523.482,206.502 526.482,206.335 529.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#aab0b3",
    d: "M 572.5,206.5 C 578.509,206.334 584.509,206.501 590.5,207C 599.586,212.674 601.252,220.007 595.5,229C 590.659,232.156 585.493,233.656 580,233.5C 579.501,237.152 579.335,240.818 579.5,244.5C 577.167,244.5 574.833,244.5 572.5,244.5C 572.5,231.833 572.5,219.167 572.5,206.5 Z M 580.5,214.5 C 585.445,213.311 588.778,214.977 590.5,219.5C 588.778,224.023 585.445,225.689 580.5,224.5C 580.016,221.049 580.016,217.716 580.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#a6abae",
    d: "M 624.5,230.5 C 622.448,231.053 622.115,232.053 623.5,233.5C 625.36,237.385 627.36,241.219 629.5,245C 626.118,245.824 622.784,245.657 619.5,244.5C 617.162,240.463 614.828,236.463 612.5,232.5C 611.508,236.783 611.174,241.116 611.5,245.5C 608.552,245.777 605.719,245.444 603,244.5C 602.5,231.838 602.333,219.171 602.5,206.5C 608.842,206.334 615.175,206.5 621.5,207C 628.694,210.22 631.527,215.72 630,223.5C 629.065,226.595 627.231,228.929 624.5,230.5 Z M 611.5,214.5 C 616.465,213.696 620.131,215.362 622.5,219.5C 620.358,224.099 616.691,225.766 611.5,224.5C 611.837,220.989 611.837,217.656 611.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.738
    },
    fill: "#878c91",
    d: "M 385.5,206.5 C 386.495,219.323 386.829,232.323 386.5,245.5C 383.615,245.806 380.948,245.473 378.5,244.5C 380.833,244.5 383.167,244.5 385.5,244.5C 385.5,231.833 385.5,219.167 385.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    fill: "#3d3e48",
    d: "M 417.5,206.5 C 417.5,219.167 417.5,231.833 417.5,244.5C 416.824,232.431 416.158,220.265 415.5,208C 416.044,207.283 416.711,206.783 417.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#a7acaf",
    d: "M 451.5,206.5 C 460.729,205.192 466.896,208.859 470,217.5C 470.667,223.5 470.667,229.5 470,235.5C 465.04,245.561 457.54,248.061 447.5,243C 444.894,241.062 443.061,238.562 442,235.5C 441.333,229.167 441.333,222.833 442,216.5C 444.022,211.98 447.189,208.647 451.5,206.5 Z M 455.5,214.5 C 460.922,216.007 463.256,219.673 462.5,225.5C 462.393,228.567 461.893,231.567 461,234.5C 457.667,238.5 454.333,238.5 451,234.5C 449,228.833 449,223.167 451,217.5C 452.409,216.219 453.909,215.219 455.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.724
    },
    fill: "#84878c",
    d: "M 475.5,206.5 C 475.5,219.167 475.5,231.833 475.5,244.5C 477.833,244.5 480.167,244.5 482.5,244.5C 480.052,245.473 477.385,245.806 474.5,245.5C 474.74,242.421 474.407,239.421 473.5,236.5C 474.144,226.372 474.811,216.372 475.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.209
    },
    fill: "#42434d",
    d: "M 529.5,206.5 C 530.167,213.167 530.833,219.833 531.5,226.5C 531.013,227.473 530.513,228.473 530,229.5C 529.5,221.841 529.334,214.174 529.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.734
    },
    fill: "#878b90",
    d: "M 572.5,206.5 C 572.5,219.167 572.5,231.833 572.5,244.5C 574.833,244.5 577.167,244.5 579.5,244.5C 577.639,245.507 574.972,245.84 571.5,245.5C 571.171,232.323 571.505,219.323 572.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#a4a9ac",
    d: "M 644.5,206.5 C 658.008,206.112 664.342,212.779 663.5,226.5C 663.508,241.655 656.175,247.488 641.5,244C 635.34,239.489 632.673,233.322 633.5,225.5C 632.863,216.414 636.53,210.08 644.5,206.5 Z M 644.5,215.5 C 648.287,214.814 651.454,215.814 654,218.5C 654.667,223.5 654.667,228.5 654,233.5C 650.466,238.734 646.8,238.734 643,233.5C 641.981,227.26 642.481,221.26 644.5,215.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.459
    },
    fill: "#5f6169",
    d: "M 390.5,213.5 C 393.167,213.5 395.833,213.5 398.5,213.5C 398.5,223.833 398.5,234.167 398.5,244.5C 400.833,244.5 403.167,244.5 405.5,244.5C 405.173,234.319 405.506,224.319 406.5,214.5C 406.5,224.833 406.5,235.167 406.5,245.5C 403.5,245.5 400.5,245.5 397.5,245.5C 397.5,235.167 397.5,224.833 397.5,214.5C 394.941,214.802 392.607,214.468 390.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.456
    },
    fill: "#65676e",
    d: "M 425.5,214.5 C 425.5,216.833 425.5,219.167 425.5,221.5C 428.059,221.198 430.393,221.532 432.5,222.5C 429.833,222.5 427.167,222.5 424.5,222.5C 424.194,219.615 424.527,216.948 425.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.468
    },
    fill: "#61636b",
    d: "M 611.5,214.5 C 611.837,217.656 611.837,220.989 611.5,224.5C 610.167,221.167 610.167,217.833 611.5,214.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.455
    },
    fill: "#6d7076",
    d: "M 531.5,244.5 C 528.375,245.479 525.042,245.813 521.5,245.5C 521.825,238.313 521.491,231.313 520.5,224.5C 520.987,223.527 521.487,222.527 522,221.5C 522.5,229.159 522.666,236.826 522.5,244.5C 525.5,244.5 528.5,244.5 531.5,244.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.733
    },
    fill: "#7f8389",
    d: "M 541.5,223.5 C 541.56,222.957 541.893,222.624 542.5,222.5C 543.497,229.803 543.831,237.137 543.5,244.5C 545.833,244.5 548.167,244.5 550.5,244.5C 548.052,245.473 545.385,245.806 542.5,245.5C 541.966,240.097 541.966,234.764 542.5,229.5C 542.795,227.265 542.461,225.265 541.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.013
    },
    fill: "#2b2b36",
    d: "M 541.5,223.5 C 542.461,225.265 542.795,227.265 542.5,229.5C 541.833,228.5 541.167,227.5 540.5,226.5C 541.11,225.609 541.443,224.609 541.5,223.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.02
    },
    fill: "#2b2b35",
    d: "M 374.5,229.5 C 374.5,230.5 374.5,231.5 374.5,232.5C 372.443,232.043 372.443,231.043 374.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.444
    },
    fill: "#5b5d64",
    d: "M 432.5,229.5 C 430.393,230.468 428.059,230.802 425.5,230.5C 425.821,235.695 425.487,240.695 424.5,245.5C 424.5,240.167 424.5,234.833 424.5,229.5C 427.167,229.5 429.833,229.5 432.5,229.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.004
    },
    fill: "#3b3b45",
    d: "M 624.5,230.5 C 623.897,231.635 623.564,232.635 623.5,233.5C 622.115,232.053 622.448,231.053 624.5,230.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.731
    },
    fill: "#7e8389",
    d: "M 308.5,232.5 C 307.564,236.735 307.231,241.069 307.5,245.5C 304.615,245.806 301.948,245.473 299.5,244.5C 301.833,244.5 304.167,244.5 306.5,244.5C 305.911,240.029 306.577,236.029 308.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.449
    },
    fill: "#55565f",
    d: "M 484.5,232.5 C 485.906,232.973 486.573,233.973 486.5,235.5C 485.094,235.027 484.427,234.027 484.5,232.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.013
    },
    fill: "#2d2d37",
    d: "M 109.5,241.5 C 112.35,245.803 111.684,246.47 107.5,243.5C 108.833,243.5 109.5,242.833 109.5,241.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.51
    },
    fill: "#4a4c55",
    d: "M 154.5,240.5 C 154.5,241.833 155.167,242.5 156.5,242.5C 152.316,245.47 151.65,244.803 154.5,240.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.694
    },
    fill: "#696c73",
    d: "M 331.5,206.5 C 331.5,219.167 331.5,231.833 331.5,244.5C 339.167,244.5 346.833,244.5 354.5,244.5C 346.684,245.492 338.684,245.826 330.5,245.5C 330.171,232.323 330.505,219.323 331.5,206.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRemovebgPreview);
export default __webpack_public_path__ + "static/media/logo-removebg-preview.e19685ddb0341f5108177fcf499f48ec.svg";
export { ForwardRef as ReactComponent };